import React from 'react'
import { IExpertStartUp } from '../../functions/_exports'

export interface PageProps {
	expert: IExpertStartUp
}

export const ExpertCardStartUp = ({ expert }: PageProps) => {
	const handleClick = (e: any) => {
		let target = $(e.target).closest('div.organization__head')
		let expanded_elem = $('.organization__head[aria-expanded="true"]').first()

		if (expanded_elem.length && expanded_elem.get(0) !== target.get(0)) {
			expanded_elem.find('i.fa-minus').addClass('fa-plus').removeClass('fa-minus')
			expanded_elem.next().slideToggle(function () {
				expanded_elem.attr('aria-expanded', expanded_elem.next().is(':visible').toString())
				target.find('i.fa-plus').addClass('fa-minus').removeClass('fa-plus')
				target.next().slideToggle(function () {
					target.attr('aria-expanded', target.next().is(':visible').toString())
				})
			})
		} else {
			if (target.next().is(':visible'))
				target.find('i.fa-minus').addClass('fa-plus').removeClass('fa-minus')
			else target.find('i.fa-plus').addClass('fa-minus').removeClass('fa-plus')
			target.next().slideToggle(function () {
				target.attr('aria-expanded', target.next().is(':visible').toString())
			})
		}

		if ($('#contact-detail').length && $('#contact-detail').attr('auto-scroll') == 'true') {
			let contact_detail_elem = $('#contact-detail')
			$('html,body').animate(
				{ scrollTop: contact_detail_elem.offset()!.top - 120 },
				1000,
				'swing'
			)
		}
	}

	const header = (
		<div
			className="organization__head row"
			aria-expanded="false"
			style={{ height: '227px' }}
			onClick={(e) => handleClick(e)}
		>
			<div
				className="col-md-3 col-sm-5 col-xs-4"
				style={{ height: '172px', margin: '15px auto' }}
			>
				<img
					className="img-responsive"
					style={{ objectFit: 'cover', height: '100%' }}
					src={`/media/${expert.photoUrl}`}
				/>
			</div>
			<div className="head-content col-md-8 col-sm-7 col-xs-8">
				<h3>
					{expert.name} {expert.surname}
				</h3>
				<hr className="hidden-xs" />
				<p className="description hidden-xs">
					{expert.bio.length > 278 ? expert.bio.substring(0, 278).concat('...') : expert.bio}
				</p>
			</div>
			<div className="col-md-1 col-sm-1 hidden-xs text-center row expand-icon">
				<i className="fa fa-plus fa-3x"></i>
			</div>
		</div>
	)

	const body = (
		<div className="organization__body row">
			<div className="text-center">
				<div id="expert-bio" dangerouslySetInnerHTML={{ __html: expert.fullBio }}></div>
				<div id="expert-contact" style={{ paddingTop: '15px' }}>
					<span className="info">Kontakt</span>
					<br />
					<a href={`mailto:${expert.contactEmail}`}>{expert.contactEmail}</a>
					<br />
					{expert.contactPhone && expert.contactPhone.length > 0 && (
						<span>{expert.contactPhone}</span>
					)}
				</div>
				<div id="expert-type" style={{ paddingTop: '15px' }}>
					<span className="info">Zameranie</span>
					<br />
					{expert.expertiseFocusList.map((focus) => (
						<span key={focus.value}>
							{focus.text}
							<br />
						</span>
					))}
				</div>

				<div id="expert-localities" style={{ paddingTop: '15px' }}>
					<span className="info">Preferované lokality</span>
					<br />
					{expert.preferredLocalityList.map((locality) => (
						<span key={locality.value}>
							{locality.text}
							<br />
						</span>
					))}
				</div>

				<div id="expert-expertise" style={{ paddingTop: '15px' }}>
					<span className="info">Služby, expertíza:</span>
					<br />
					{expert.expertiseList.map((expertise) => (
						<span key={expertise.value}>
							{expertise.text}
							<br />
						</span>
					))}
				</div>
			</div>
			<div className="organization__body__content col-md-5"></div>
		</div>
	)

	return (
		<div className="col-md-12">
			{header}
			{body}
		</div>
	)
}
